import { SelectedFile } from '../useBasicFileUpload';
import { validate, ValidationRule } from './validate';

export function validateFile(file: File, validationRules: ValidationRule[]): Promise<SelectedFile> {
  return Promise.resolve({ file, errors: validate(file, validationRules) });
}
